import React from 'react';
import styled from 'styled-components/macro';
import { useSelector } from '../../redux/modules/helpers/useSelector';
import { useJoinUrl } from 'src/client/components/buttons/JoinButton';
import { HeaderItemWithPopover } from './HeaderItemWithPopover';
import { HeaderPopovers } from './HeaderProvider';
import { Popover, StyledAnchor, StyledNavLink } from './InternalLinks';
import { TABLET_LANDSCAPE } from 'src/client/constants/mediaQueries';

export const MoreGirls = () => {
  const user = useSelector((state) => state.auth.user);
  const site = useSelector((state) => state.site);
  const { hasMoreGirls, shop } = useSelector((state) => state.app.config);
  const [joinUrl] = useJoinUrl({ campaign: 'more-girls' });

  if (!user?.validSubscription || !hasMoreGirls) {
    return null;
  }

  const goddessMeUrl = `https://goddess.me/?utm_medium=web&utm_source=${site.abbreviation}&utm_campaign=more-girls`;

  return (
    <MoreGirlsWrapper headerPopover={HeaderPopovers.MOREGIRLS} menuText="More Girls" staticContent menuLink="">
      <Popover>
        <StyledAnchor className="left" href={joinUrl}>
          Our Beautiful Girls
        </StyledAnchor>
        <StyledNavLink className="left" to="/trusted-partners">
          Trusted Partner Sites
        </StyledNavLink>
        {shop && (
          <StyledAnchor className="left" href={shop.domain} target="_blank" rel="noreferrer">
            {shop.name}
          </StyledAnchor>
        )}
        <StyledAnchor className="left" href={goddessMeUrl}>
          Intimate Toys
        </StyledAnchor>
      </Popover>
    </MoreGirlsWrapper>
  );
};

const MoreGirlsWrapper = styled(HeaderItemWithPopover)`
  display: none;

  @media ${TABLET_LANDSCAPE} {
    display: inline-flex;
  }
`;
